import { TextAlignment } from '@gitbook/api-client';
import {
    BLOCK_PARAGRAPH,
    type BlockHeadingData,
    type BlockParagraphData,
    heading,
} from '@gitbook/doc-core';
import { type Change, TextRange } from '@gitbook/slate';
import type { Plugin } from '@gitbook/slate-react';

import { isBackspace } from '../common';

export const plugin: Plugin = {
    onKeyDown,
};

function onKeyDown(event: KeyboardEvent, change: Change): Change | void {
    if (isBackspace(event)) {
        return onBackspace(event, change);
    }

    return undefined;
}

function onBackspace(event: KeyboardEvent, change: Change): Change | void {
    const { value } = change;
    const selection = value.selection;

    if (!TextRange.isTextRange(selection) || selection.isExpanded) {
        return undefined;
    }

    if (selection.startOffset > 0) {
        return undefined;
    }

    const { startBlock } = value;
    if (!startBlock) {
        return undefined;
    }

    if (startBlock.type !== BLOCK_PARAGRAPH && !heading.isHeading(startBlock)) {
        return undefined;
    }

    if (!selection.hasAnchorAtStartOf(startBlock)) {
        return undefined;
    }

    const { align } = startBlock.data.toFrozenObject() as BlockParagraphData | BlockHeadingData;

    if (align === TextAlignment.End) {
        event.preventDefault();
        change.setDataByKey(startBlock.key, ['align'], TextAlignment.Center);
        return change;
    }

    if (align === TextAlignment.Center) {
        event.preventDefault();
        change.removeDataByKey(startBlock.key, ['align']);
        return change;
    }

    return undefined;
}
